import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import type LocationCommonWellItemViewState from '../store/schema/LocationCommonWellItemViewState';
import { createLocationPersonaFromEnhancedLocation } from 'owa-location-persona';

/**
 * Converts enhanced locations to common wellLocations
 * @param locations enhanced locations
 */
export default function getLocationCommonWellItemsFromEnhancedLocation(
    locations: EnhancedLocation[]
): LocationCommonWellItemViewState[] {
    return locations
        ? locations.map(location => {
              return {
                  persona: createLocationPersonaFromEnhancedLocation(location),
                  text: location.DisplayName,
                  isValid: true,
                  isSelected: false,
                  isContextMenuOpen: false,
              } as LocationCommonWellItemViewState;
          })
        : [];
}
